<template>
  <div class="agent-investment">
    <div class="fil-brand">
      <span
        style="
          font-size: 20px;
          font-weight: 600;
          width: 100px;
          margin-bottom: 5px;
        "
        >品牌筛选 :
      </span>
      <div class="fil-brand-box">
        <div
        id="brandItem"
          :class="$store.state.currentBrandIndex == key ? 'BrandActive' : ''"
          v-for="(value, key) in $store.state.brandList"
          :key="key"
          @click="getbrandkey(value, key)"
        >
          {{ value }}
        </div>
      </div>
    </div>
    <div style='display: flex;
    align-items: center;
    justify-content: space-between;'>
       <span class="h3">PRODUCT INFORMATION</span>
        <div class="search">
          <input
            type="text"
            placeholder="请输入关键词"
            v-model="Keywords"
            @keyup.enter="searchKeywords"
          />
          <div class="yellowbtn"  @click="searchKeywords">
            <Icon type="ios-search" size="18" color="#003871"/>
          </div>
        </div>
    </div>
   
    <div class="table-img">
      <div v-html="description">{{ description }}</div>
    </div>
    <div class="table-main">
      <ul v-if="itemData && itemData.length > 0">
        <li
          v-for="(item, index) in itemData"
          :class="currentIndex == index ? 'active' : ''"
          :key="index"
          @click="getShopData(item.id, index)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="main-box" v-if="productData.length > 0">
      <ul class="box-ul" v-for="(item, index) in productData" :key="index">
        <div class="box" style="display:flex;justify-content:space-between">
          <div class="box-left" style="width:85%">
              <h3 class="name" @click="goxq(item.goods_code)">
                {{ item.goods_code }}
              </h3>
              <h3 class="name" @click="goxq(item.goods_code)">{{ item.name }}</h3>
              <p class="brand">
                品牌：<span
                  v-show="item.brand !== null"
                  :style="`background:${item.background_color};color:#ffbb00;padding:1px 10px;border-radius:20px`"
                  >{{ item.brand }}</span
                >
              </p>
              <p>
                <span class="key"
                  >英文名称：<span>{{ item.name_en }}</span></span
                >
                <span class="key"
                  >储存条件：<span>{{ item.storage }}</span></span
                >
                <span class="key"
                  >运输方式：<span>{{ item.transport }}</span></span
                >
                <span class="key"
                  >保质期：<span>{{ item.life }}</span></span
                >
                <span class="key"
                  >商品属性：<span>{{ item.attribute }}</span></span
                >
              </p>
          </div>
        <div v-if="item.tag && item.tag.length > 0" class="box-right" style="width:15%;margin-left:20px">
            <div style="color:#333;font-size:15px;margin-bottom:10px;" v-for="(item,index) in item.tag.slice(0,5)" :key="index">
              <div style="width:80%;text-align:center;background:#fff1f0;color:#ff7677;border:1px solid #ff7677;padding:2px 5px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;">{{item}}</div>
            </div>
          </div>
        </div>
        <el-collapse
          accordion
          v-model="activeNames"
          @change="handleChanges(item.goods_code, item)"
        >
          <el-collapse-item title="价格库存" :name="item.goods_id">
            <div class="table">
              <ul class="table-head">
                <li style="width: 136px">货号</li>
                <li style="width: 136px">规格</li>
                <li style="width: 136px">货期</li>
                <li style="width: 136px">价格</li>
                <li style="width: 186px">数量</li>
                <li style="width: 136px">加入购物车</li>
              </ul>
              <ul class="table-body" v-for="(i, v) in skuList" :key="v">
                <li style="width: 136px">{{ i.customer_sku }}</li>
                <li style="width: 136px">{{ i.spec }}</li>
                <li style="width: 136px">
                  {{ i.stock > 0 ? "现货" : i.delivery }}
                </li>
                <li style="width: 136px">
                  <div
                    class="newPrice"
                  >
                    <span class="old">￥{{ i.original_price }}</span>
                    <span class="new">￥{{ i.discount_price }}</span>
                  </div>
                  <!-- <span v-if="i.is_discount == 0">￥{{ i.price }}</span> -->
                </li>
                <li style="width: 186px">
                  <el-input-number
                    v-model="i.num"
                    @change="handleChange"
                    :min="1"
                    label="加入购物车"
                  ></el-input-number>
                </li>
                <li style="width: 136px">
                  <button class="addcar" @click="addShopCar(i.sku_id, i.num)">
                    <Icon type="md-cart" size="20" />
                  </button>
                </li>
              </ul>
            </div>
          </el-collapse-item>
        </el-collapse>
      </ul>
          <div class="person-tag__list-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="this.$store.state.pageIndex"
          :page-sizes="[5, 10, 20, 30]"
          background
          layout="total, sizes , prev, pager, next"
          :total="this.$store.state.total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="kong" v-else>
      <div v-if="loading" v-loading="loading"></div>
      <div v-else>
            <h3>温馨提示</h3>
            <p>很抱歉，未找到您要的产品</p>
            <p>请咨询在线客服或拨打热线 400-088-0777</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      list: [],
      // currentIndex: 'four',
      IsToken: localStorage.getItem("token")
        ? localStorage.getItem("token")
        : "",
      skuList: [],
      activeNames: ["36"],
      storageVal: "",
      brandNames: {},
      Keywords:'',
      loading:false
    };
  },
  computed: {
    ...mapState(["itemData", "productData", "description", "currentIndex"]),
  },
  created(){
    this.loading = true
    if(this.productData.length>0){
      this.loading = false
    }else{
      setTimeout(()=>{
        this.loading = false
      },2000)
    }
  },
  methods: {
    searchKeywords(){
        this.getShopData(this.$store.state.category_id,1);
    },
    getbrandkey(val, key) {
      if(this.$store.state.currentBrandIndex == key){
         this.$store.state.currentBrandIndex = "";
      }else{
        this.$store.state.currentBrandIndex = key;
      }
      this.$store.state.pageIndex = 1;
      this.getShopData(this.$store.state.category_id);
    },
    goxq(id) {
      let routeUrl = this.$router.resolve({
        path: `/homepage/detail`,
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    handleSizeChange(val) {
      this.$store.state.pageSize = val;
      this.getShopData(this.$store.state.category_id);
    },
    handleCurrentChange(val) {
      this.$store.state.pageIndex = val;
      this.getShopData(this.$store.state.category_id);
    },
    handleChanges(val, item) {
      this.$api.productCenter
        .skuList({
          goods_code: val,
        })
        .then((res) => {
          const arr = res.data;
          arr.forEach((item) => {
            item.num = 1;
          });
          this.skuList = res.data;
        });
    },
    handleClick(val) {},
    handleChange(value) {},
    getShopData(id, index) {
      this.$store.state.category_id = id;
      this.$store.state.currentIndex = index;
      if (index !== undefined) {
        this.$store.state.pageIndex = 1;
      }
    this.$api.productCenter
          .getShopData({
            category_id: id,
            brand_id: this.$store.state.currentBrandIndex,
            keyword:this.Keywords,
            page: this.$store.state.pageIndex,
            limit: this.$store.state.pageSize,
          })
          .then((res) => {
            this.$store.state.total = res.count;
            const arr = res.data.items;
            this.$store.state.brandList = res.data.brand_list
            this.$store.state.productData = arr;
          });
    },
    addShopCar(id, num) {
      //加入购物车接口
      this.$api.shopCar
        .addcar({
          sku_id: id,
          num: num,
        })
        .then((res) => {
          if (res.status == 1) {
            this.$message.closeAll();
            this.$message({
              message: "已成功加入购物车",
              type: "success",
            });
          }
        });
    },
  }
};
</script>

<style lang="less" scoped>
.kong {
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #000000;
  line-height: 50px;
}
.h3,
.h2 {
  font-size: 26px;
  color: #333333;
}
/deep/.el-collapse-item__arrow {
  color: #ffbb00;
  font-weight: 600;
  font-size: 16px;
}
.table-main {
  width: 876px;
  display: flex;
  margin-top: 20px;
  ul {
    font-size: 12px;
    color: #333333;
    line-height: 22px;
    display: flex;
    flex-wrap: wrap;
    li {
      padding: 10px;
      margin-bottom: 10px;
      height: 40px;
      border-bottom: none;
      font-size: 12px;
      text-align: center;
      cursor: pointer;
      margin-right: 10px;
      background: #003871;
      color: #ffbb00;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      &.active {
        background: #ffbb00;
        color: #003871;
      }
    }
  }
}
.agent-investment {
  margin-bottom: 20px;
  .fil-brand{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .fil-brand-box{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    #brandItem{
      margin: 0px 8px;
      font-size: 18px;
      border:1px solid #ffbb00;
      border-radius: 20px;
      padding:2px 12px;
      cursor: pointer;
      margin-bottom: 5px;
    }
    .BrandActive{
      background: #ffbb00;
      color:#003871
    }
  }
}
.main-box {
  width: 876px;
  font-size: 14px;
  color: #333333;
  .box-ul {
    border: 1px solid #ccc;
    margin-bottom: 10px;
    width: 100%;
    min-height: 120px;
    /deep/.el-collapse-item__header {
      background: #efefef;
      padding: 0px 22px;
      color: #003871;
      font-size: 16px;
      font-weight: 600;
    }
    /deep/.el-collapse-item__content {
      padding-bottom: 0px;
    }
    .box {
      margin: 20px;
      font-size: 14px;
      .key {
        margin-right: 20px;
        span {
          color: #999;
          font-size: 14px;
        }
      }
      .brand {
        color: #999;
        span {
          color: #a52a2a;
          font-size: 14px;
        }
        img {
          width: 70px;
          height: 21px;
          background: #003871;
        }
      }
      h3 {
        span {
          color: #a52a2a;
        }
      }
      .name:hover {
        color: #a52a2a;
        text-decoration-line: underline;
        cursor: pointer;
      }
    }
    .table {
      margin: 10px;
      .table-head {
        height: 40px;
        display: flex;
        align-items: center;
        background: #eff0f2;
        color: #003871;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
      }
      .table-body {
        display: flex;
        align-items: center;
        min-height: 60px;
        border-bottom: 1px solid #eee;
        text-align: center;
        .newPrice {
          .old {
            text-decoration: line-through;
            display: block;
          }
          .new {
            color: red;
          }
        }
      }
      .addcar {
        border: 0px;
        background: #fff;
        color: #a52a2a;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #a52a2a !important;
}
/deep/.person-tag__list-pagination {
  text-align: center;
  margin-top: 20px;
  span {
    font-weight: 600;
  }
}

.search {
  position: relative;
  width: 200px;
  height: 35px;
  input {
    width: 200px;
    height: 35px;
    background: #ffffff;
    border: 1px solid #f7b500;
    border-radius: 22px;
    padding-left: 15px;
    font-size: 12px;
  }
  input:focus{outline:none;}
  input::-webkit-input-placeholder {
    color: #696969;
    font-size: 12px;
  }
  .yellowbtn {
    cursor: pointer;
    position: absolute;
    top: 0px;
    left: 162px;
    width: 48px;
    height: 35px;
    background: #f7b500;
    border: 1px solid #f7b500;
    border-radius: 0px 22px 22px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>